import { Component, ViewChild } from '@angular/core';
import { generalService } from '../../services/general.service';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { modalComponent } from '../../utils/modal/modal.component';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';


@Component({
  selector: 'descuentos-consultar',
  styleUrls: [],
  templateUrl: 'descuentos-consultar.component.html',
  providers: [generalService]
})

export class DescuentosConsultarComponent{
  public title = 'Descuentos Maximo';
  public divConsult:boolean = true;
  public divEdit:boolean = false;
  public divElement:boolean = true;
  public discountForm: FormGroup;
  public descDelete:number;
  public idDescuento: number;
  public idUsuario:number;
  public nombreUsuario:string;
  public idFamilia:number;
  public familiaTodos:number;
  public idSubfamilia:number;
  public subfamiliaTodos:number;
  public idProducto:number;
  public productoTodos:number;
  public maxDescuento:number;
  public status:string;
  public active:number;

  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public userCompany:number = this.userData.COMPANY_ID;
  public userEditor:number = this.userData.USER_ID;
  public dataSource: DataSourceGrid | null;
  public displayedColumns = ['acciones', 'nombre', 'compania', 'sucursal', 'estatus'];
  public usuariosList: any[];
  public descuentosList: any;
  public descuentosDelete: any[];
  public matOptions: any;
  public numberOfRecords = 0;
  public contName: number = 0;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  constructor(private _generalService: generalService,
              private formBuilder: FormBuilder,
              public dataService: DataService,
              private route: ActivatedRoute, 
              private router: Router,
              public dialog: MatDialog /*,
              private cdr: ChangeDetectorRef*/) {
    this.descuentosList = new Array();
    this.descuentosDelete = new Array();
               }

  ngOnInit() {
    this.consultUsuarios();
    this.buildDiscountList();
    this.buildMatOptionsList();
  }

  buildDiscountList(){ this.discountForm = this.formBuilder.group({}); }

  agregarNuevosFormBuilder(indice: number) {
    this.discountForm.addControl('familia' + indice, this.formBuilder.control(null, [Validators.required]));
    this.discountForm.addControl('tipo' + indice, this.formBuilder.control(null, [Validators.required]));
    this.discountForm.addControl('producto' + indice, this.formBuilder.control(null, [Validators.required]));
    this.discountForm.addControl('descuentoMax' + indice, this.formBuilder.control(null, [Validators.required]));
  }

  eliminarFormBuilder(indice: number) {
    this.discountForm.removeControl('familia' + indice);
    this.discountForm.removeControl('tipo' + indice);
    this.discountForm.removeControl('producto' + indice);
    this.discountForm.removeControl('descuentoMax' + indice);
  }

  buildMatOptionsList() {
    this.matOptions = new Object();
    this.matOptions.families = [];
    this.matOptions.subFamilies = [];
    this.matOptions.item = [];
  }

  consultUsuarios() {
    this._generalService.metodoCallParams(this.userCompany, 'descuento/consultDiscountUsers')
        .subscribe(userList => {
          this.usuariosList = JSON.parse(userList);
          this.numberOfRecords = this.usuariosList.length;

          if (this.usuariosList.length > 0) {
            this.dataSource = new DataSourceGrid(this.usuariosList, this.paginator, this.sort); } 
          else { this.dataSource = undefined;  }
        }, error => {
          // Custom error handler
        });
  }

  consultDescuentos(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCallParams(this.idUsuario, 'descuento/consultDiscountById')
          .subscribe(discountList => {
            discountList = JSON.parse(discountList);
            this.descuentosList = discountList;

            for (let i = 0; i < this.descuentosList.length; i++) {
              this.contName = this.descuentosList[i].idCounter;
              this.agregarNuevosFormBuilder(this.contName);
            }

            resolve();
          }, error => {
            // Custom error handler
            reject();
          });
    });
  }

  consultFamilias(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCallParams(this.userCompany, 'descuento/consultFamilies')
          .subscribe(itemFamily => {
            itemFamily = JSON.parse(itemFamily);
            this.matOptions.families = itemFamily;
            resolve();
          }, error => {
            // Custom error handler
            reject();
          });
    });
  }

  consultSubFamilias(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCallParams(this.userCompany, 'descuento/consultSubFamilies')
          .subscribe(itemSubFamily => {
            itemSubFamily = JSON.parse(itemSubFamily);
            this.matOptions.subfamilies = itemSubFamily;
            resolve();
          }, error => {
            // Custom error handler
            reject();
          });
    });
  }

  consultProductos(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCallParams(this.userCompany, 'descuento/consultItem')
          .subscribe(item => {
            item = JSON.parse(item);
            this.matOptions.item = item;
            resolve();
          }, error => {
            // Custom error handler
            reject();
          });
    });
  }

  gotoEdit (discountUser:string, idUser:number) {
    this.divConsult = false;
    this.divEdit = true;
    this.nombreUsuario = discountUser;
    this.idUsuario = idUser;
    this.consultFamilias();
    this.consultSubFamilias();
    this.consultProductos();
    this.consultDescuentos();
  }

  AddToList(){
    if (this.contName > 0) {
      this.contName++;
      this.agregarNuevosFormBuilder(this.contName);
    } else if (this.contName === 0) {
      this.agregarNuevosFormBuilder(this.contName);
    }
    this.descuentosList.push({idCounter: this.contName, idDiscount: this.idDescuento, idFamily: this.idFamilia, 
      familyAll: this.familiaTodos, idSubfamily: this.idSubfamilia, subfamilyAll: this.subfamiliaTodos, 
      idItem: this.idProducto, itemAll: this.productoTodos, maxDiscount: this.maxDescuento, status: 'add', active: 1});
  }

  removeFromList(indice: number) {
    const contName = this.descuentosList[indice].contProduct;
    if (this.descuentosList[indice].status === 'add') {
      this.descuentosList.splice(indice, 1);
    } else {
      this.descuentosList[indice].status = 'delete';
      this.descuentosList[indice].active = 0;
      //this.descuentosDelete.push(this.descuentosList[indice]);
      this.descuentosList.splice(indice, 1);
    }
    this.eliminarFormBuilder(contName);
  }
  
  saveDiscountList(){
    this.divConsult = true;
    this.divEdit = false;
  }

  updateDocument() {
    this.descuentosList.loacs = sessionStorage.getItem('acslo');
    const descuentosEdit = JSON.parse(JSON.stringify(this.descuentosList));
    if (this.descuentosDelete.length > 0) {
      this.descuentosList = descuentosEdit.descuentosList.concat(this.descuentosDelete);
    }

    this._generalService.metodoCallParams(descuentosEdit, 'descuento/UpdateDocument').subscribe(
      (result) => {
        if (result !== 'Los descuentos se actualizaron correctamente') {
          this.modal('alert', result);
        } else {
          this._generalService.toastCall(result);
          this.router.navigate(['app/descuentos']);
        }
      },
      (error) => {
        console.error(error as any);
      }
    );
  }

  modal(tipo: string, mensaje: string) {
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
    // dialogModal.afterClosed().subscribe((result) => {});
  }
}



// WEBPACK FOOTER //
// ./src/app/descuentos/consultar/descuentos-consultar.component.ts